<template>
  <teleport to="body">
    <div v-if="visible" class="adminModal">
      <div class="adminModal__box">
        <div class="adminModal__head">
          <div class="adminModal__title">{{ title }}</div>
          <div class="adminModal__headRight">
            <slot name="header"/>
            <button class="adminModal__close" title="Закрыть" @click="closeHandler">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="adminModal__body">
          <slot/>
        </div>
        <div v-if="$slots.footer" class="adminModal__footer">
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import {useImagePreview} from "@/composables/image-preview";

export default {
  name: "AdminModal",
  props: {
    visible: {type: Boolean, default: false},
    title: {type: String, default: ""},
  },
  emits: ['close'],
  methods: {
    closeHandler() {
      this.$emit('close');
    },
    onKeydown(e) {
      if (e.key !== 'Escape' || !this.visible) {
        return;
      }
      // Если открыт предпросмотр изображения, Esc закрывает только его,
      // окно редактирования должно остаться открытым.
      if (useImagePreview().isOpen.value) {
        return;
      }
      this.closeHandler();
    },
    lockBodyScroll(lock) {
      document.body.style.overflow = lock ? 'hidden' : '';
      if (lock) {
        document.body.classList.add('adminModal--lock');
      } else {
        document.body.classList.remove('adminModal--lock');
      }
    },
    removePointerEventsOverride() {
      // Не нужно — управляем через класс на body
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
    if (this.visible) {
      this.lockBodyScroll(true);
    }
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeydown);
    this.lockBodyScroll(false);
  },
  watch: {
    visible(val) {
      this.lockBodyScroll(val);
    }
  }
}
</script>

<style lang="scss">
.adminModal--lock {
  pointer-events: none;

  .adminModal {
    pointer-events: auto;
  }
}
</style>

<style scoped lang="scss">
.adminModal {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 60px 16px 16px;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.55);

  &__box {
    background: var(--cd-card-bg);
    border-radius: 20px;
    padding: 24px;
    width: 100%;
    max-width: 720px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: left;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  }

  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  &__headRight {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__title {
    color: var(--cd-base-green);
    font-size: 16px;
    font-family: var(--cd-default-font);
  }

  &__close {
    background: transparent;
    border: none;
    color: var(--cd-text-muted);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 6px;
    transition: color 0.3s;

    &:hover {
      color: var(--cd-danger);
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__footer {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
}
</style>